var _rect, _g, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10593_19814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#paint0_linear_10593_19814)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10593_19814)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#D6EBFF",
    stroke: "#99CEFF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1890FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4025 16.8777C23.5946 16.4886 23.6906 16.2941 23.821 16.2319C23.9344 16.1778 24.0662 16.1778 24.1797 16.2319C24.31 16.2941 24.4061 16.4886 24.5981 16.8777L26.4204 20.5694C26.4771 20.6843 26.5054 20.7417 26.5469 20.7863C26.5836 20.8258 26.6276 20.8578 26.6764 20.8805C26.7316 20.9062 26.795 20.9154 26.9218 20.934L30.9978 21.5297C31.427 21.5925 31.6417 21.6238 31.741 21.7287C31.8274 21.8199 31.868 21.9452 31.8516 22.0698C31.8327 22.213 31.6773 22.3643 31.3666 22.667L28.4182 25.5387C28.3263 25.6282 28.2803 25.6729 28.2507 25.7262C28.2244 25.7734 28.2076 25.8252 28.2011 25.8787C28.1937 25.9392 28.2046 26.0025 28.2263 26.1289L28.922 30.1851C28.9953 30.6129 29.032 30.8268 28.9631 30.9537C28.9031 31.0642 28.7965 31.1416 28.6729 31.1645C28.5308 31.1909 28.3388 31.0899 27.9546 30.8878L24.3106 28.9715C24.1971 28.9118 24.1403 28.8819 24.0805 28.8702C24.0276 28.8598 23.9731 28.8598 23.9202 28.8702C23.8603 28.8819 23.8036 28.9118 23.69 28.9715L20.0461 30.8878C19.6619 31.0899 19.4698 31.1909 19.3278 31.1645C19.2042 31.1416 19.0976 31.0642 19.0376 30.9537C18.9687 30.8268 19.0053 30.6129 19.0787 30.1851L19.7744 26.1289C19.7961 26.0025 19.8069 25.9392 19.7996 25.8787C19.7931 25.8252 19.7763 25.7734 19.75 25.7262C19.7203 25.6729 19.6744 25.6282 19.5825 25.5387L16.6341 22.667C16.3234 22.3643 16.168 22.213 16.1491 22.0698C16.1326 21.9452 16.1733 21.8199 16.2597 21.7287C16.359 21.6238 16.5736 21.5925 17.0029 21.5297L21.0789 20.934C21.2057 20.9154 21.2691 20.9062 21.3243 20.8805C21.3731 20.8578 21.4171 20.8258 21.4538 20.7863C21.4952 20.7417 21.5236 20.6843 21.5803 20.5694L23.4025 16.8777Z",
    stroke: "white",
    strokeWidth: 1.336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10593_19814",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5aa0af5a95cd89d146aaaeac5e235d93.svg";
export { ForwardRef as ReactComponent };